import React, { useContext, useState } from 'react';
import DataTable from '@preflighttech/preflight-tables';
import { Text, View, Pressable } from 'react-native';
import { FEE_ESTIMATES_WITH_COUNT, HIDE_FEE_ESTIMATE } from './queries';
import { useMutation } from '@apollo/client';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';
import {
   MainContainer,
   ContentContainer,
   TableContainer,
   PageTitle,
   LinkContainer,
   TableNavbarContainer,
   LinkSpace,
   SubNavContainer
} from '../../../elements';
import moment from 'moment';
import { STATUSES } from '../elements';
import Modal from '../../../elements/Modal';
import EditFee from '../edit';
import { formatAssetNameForSelect } from '../../../utils/formatAssetName';
import currencyFormatter from '../../../utils/currencyFormatter';
import ResourceNotifications from '../../Notifications/Resource';
import AuthContext from 'app/src/contexts/AuthContext';

import NewFee from '../new';
import EstimateFunctions from './EstimateFunctions';
import FeeEstimateFunctionsLegend from './EstimateFunctionsLegend';

const inputStyle = {
  marginBottom: '10px'
}

const FeeEstimates = (props) => {
  const { asset, feeRefetch } = props;
  const [refetch, setRefetch] = useState();
  const [clickedFee, setClickedFee] = useState();
  const [showAddFeeModal, setShowAddFeeModal] = useState(false);
  const [showEditFeeEstimateModal, setShowEditFeeEstimateModal] = useState(false);
  const [feeEstimate, setFeeEstimate] = useState(false);
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const { hasPolicy } = useContext(AuthContext);

  const queryVariables = {
    assetId: asset?.id,
    filterColumns: [],
    filterNames: [],
    scopes: ['active'],
  };
  const [hideFeeEstimate] = useMutation(
    HIDE_FEE_ESTIMATE, { onCompleted: refetch }
  )

  const onHide = (feeEstimateId) => {
    hideFeeEstimate({ variables: { id: feeEstimateId }});
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const columns = [
    {
      key: '',
      label: '',
      sort: 'prevent',
      search: false,
      content: (entry) => {
        return (
          <View style={{alignItems: 'center'}}>
            <ResourceNotifications
              resource={entry.entry}
            />
          </View>
        )
      }
    },
    {
      key: 'status',
      label: 'Status',
      content: (entry) => entry.entry.status
    },
    {
      key: 'type',
      label: 'Type',
      content: (entry) => {
        return entry.entry.type
      }
    },
    {
      key: 'buyerFee',
      label: 'Buyer Fee?',
      content: (entry) => {
        return entry.entry.buyerFee ? 'Yes' : 'No'
      }
    },
    {
      key: 'amount',
      label: 'Amount',
      content: (entry) => {
        return currencyFormatter(entry.entry.amount);
      }
    },
    {
      key: 'counterAmount',
      label: 'Counter Amount',
      content: (entry) => {
        if(entry.entry.counterAmount) {
          return currencyFormatter(entry.entry.counterAmount)
        }
      }
    },
    {
      key: 'description',
      label: 'Description',
      content: (entry) => {
        return entry.entry.description
      }
    },
    {
      key: 'functions',
      label: 'Functions',
      sort: 'prevent',
      content: (entry) => {
        return (
          <LinkContainer>
            <EstimateFunctions
              feeEstimate={entry.entry}
              refetch={refetch}
              feeRefetch={feeRefetch}
            />
          </LinkContainer>
        )
      }
    }
  ]

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >
        {/* <View style={{padding: '20px', justifyContent: 'space-between'}}>
          <Text>Sale Name:</Text>
          <input
            type={'text'}
            name="name"
            onChange={e => setFilter('name', e.target.value)}
            value={filters.name || ''}
            style={inputStyle}
          />
          <Text>Start:</Text>
          <input
            type={'text'}
            name="startAt"
            onChange={e => setFilter('startAt', e.target.value)}
            value={filters.startAt || ''}
            style={inputStyle}
          />
          <Text>End:</Text>
          <input
            type={'text'}
            name="endAt"
            onChange={e => setFilter('endAt', e.target.value)}
            value={filters.endAt || ''}
            style={inputStyle}
          />
          <Text>Pre Bid Open At:</Text>
          <input
            type={'text'}
            name="preBidOpenAt"
            onChange={e => setFilter('preBidOpenAt', e.target.value)}
            value={filters.preBidOpenAt || ''}
            style={inputStyle}
          />
          <Text>Status:</Text>
          <select
            type={'select'}
            name="status"
            onChange={e => setFilter('status', e.target.value)}
            value={filters.status || ''}
          >
            <option key={`status-all`}>
              {'All'}
            </option>
            {STATUSES.map(status =>
              <option key={`status-${status}`}>
                {status}
              </option>
            )}
          </select>
        </View> */}
      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      <ContentContainer>
        <PageTitle>Fee Estimates</PageTitle>
        <br /><br />
        <TableContainer>
          {/* <SubNav refetch={refetch} tableNav={true} asset={asset} /> */}
          {getSubNavContents()}
          <FeeEstimateFunctionsLegend />
          <DataTable.Gql
            setRefetch={setRefetch}
            query={FEE_ESTIMATES_WITH_COUNT}
            queryName='feeEstimatesWithCount'
            columns={columns}
            // buttons={buttons}
            lengthMenu={ [10, 25, 50, 'All'] }
            setSettings={setSettings}
            dataUpdated={data => setFilterOptions(data?.feeEstimatesWithCount)}
            htmlTable
            queryVariables={queryVariables}
          />
        </TableContainer>
      </ContentContainer>
      {showEditFeeEstimateModal &&
        <Modal
          refetch={refetch}
          showModal={showEditFeeEstimateModal}
          setShowModal={setShowEditFeeEstimateModal}
          modalType={'Edit Fee Estimate'}
          objectName={clickedFee.name}
        >
          <EditFee
            setShowModal={setShowEditFeeEstimateModal}
            refetch={refetch}
            fee={clickedFee}
            asset={asset}
          />
        </Modal>
      }
    </MainContainer>
  )
  function getSubNavContents() {
    return (
      <SubNavContainer>
        {getLinks()}
      </SubNavContainer>
    )
    function getLinks() {
      if (!hasPolicy({ type: 'Fee', action: 'create' })) {
        return null;
      }

      return (
        <View style={{display: 'flex', flexDirection: 'row'}}>
          <Pressable
            onPress={() => {
              setShowAddFeeModal(true)
              setFeeEstimate(true)
            }}
          >
            <Text>+ Add Fee Estimate</Text>
          </Pressable>
          {showAddFeeModal &&
            <Modal
              showModal={showAddFeeModal}
              setShowModal={setShowAddFeeModal}
              modalType={'Add Fee'}
            >
              <NewFee
                setShowModal={setShowAddFeeModal}
                refetch={refetch}
                knownAsset={asset}
                feeEstimate={feeEstimate}
                setFeeEstimate={setFeeEstimate}
              />
            </Modal>
          }
        </View>
      )
    }
  }
}

export default FeeEstimates;
